import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import CourseProvider from "./components/Course/CourseContext";
import AuthProvider from "./components/Auth/AuthContext";
import * as Storage from "ts-storage";
import { setAuthorization } from "./utils/tokenAPI";
import { BrowserRouter as Router } from "react-router-dom";
import { LastLocationProvider } from "react-router-last-location";
import CartProvider from "./components/Cart/CartContext";

export let base_url =
  "https://birunidev-course-app.herokuapp.com" || "http://192.168.100.115:1337";

if (process.env.NODE_ENV === "production") {
  base_url = "https://birunidev-course-app.herokuapp.com";
}

let jwtToken = Storage.get("token", "").value;
setAuthorization(jwtToken);

ReactDOM.render(
  <AuthProvider>
    <CartProvider>
      <CourseProvider>
        <Router>
          <LastLocationProvider>
            <App />
          </LastLocationProvider>
        </Router>
      </CourseProvider>
    </CartProvider>
  </AuthProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
